export default __webpack_public_path__ + "static/media/talkingbadges_preview.547048eb.png";